// extracted by mini-css-extract-plugin
module.exports = {"NewsItem":"NewsItem-module--NewsItem--Rbjzk","NewsItem_Body":"NewsItem-module--NewsItem_Body--Opm7O"};